var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-viewer"},[(_vm.show)?_c('b-card',{staticClass:"mt-3",attrs:{"no-body":"","header":"JSON Format"}},[_c('pre',[_c('code',[_vm._v(_vm._s(_vm.formString))])])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }